/**
 * @generated SignedSource<<790d884ba54b9a05df3c5a2c4f07d0cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CommiterSelectQuery$variables = {
  changeLocator: string;
};
export type CommiterSelectQuery$data = {
  readonly changeCommiters: {
    readonly commiter: ReadonlyArray<{
      readonly users: {
        readonly user: ReadonlyArray<{
          readonly avatars: {
            readonly urlToSize40: string | null | undefined;
          } | null | undefined;
          readonly id: Branded<number, 'UserId'> | null | undefined;
          readonly name: string | null | undefined;
        }> | null | undefined;
      } | null | undefined;
      readonly vcsUsername: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type CommiterSelectQuery = {
  response: CommiterSelectQuery$data;
  variables: CommiterSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "changeLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "changeLocator",
    "variableName": "changeLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vcsUsername",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "UserAvatars",
  "kind": "LinkedField",
  "name": "avatars",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlToSize40",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommiterSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Commiters",
        "kind": "LinkedField",
        "name": "changeCommiters",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Commiter",
            "kind": "LinkedField",
            "name": "commiter",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Users",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommiterSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Commiters",
        "kind": "LinkedField",
        "name": "changeCommiters",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Commiter",
            "kind": "LinkedField",
            "name": "commiter",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Users",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "_id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4fa97e54a5cbd7d512f86540da96fb8e",
    "id": null,
    "metadata": {},
    "name": "CommiterSelectQuery",
    "operationKind": "query",
    "text": "query CommiterSelectQuery(\n  $changeLocator: String!\n) {\n  changeCommiters(changeLocator: $changeLocator) {\n    commiter {\n      vcsUsername\n      users {\n        user {\n          id\n          name\n          avatars {\n            urlToSize40\n          }\n          _id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b38f1695d2af6111bc5e2058c86792ce";

export default node;
